/* Ygeia cart drawer engine — Shopify AJAX Cart API.
   Opens from the header cart button and after add-to-cart; renders lines from
   /cart.js; quantity + remove via /cart/change.js; checkout hands off to the
   hosted /checkout. Progressive: if a fetch fails, the native form still posts. */
(function () {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  root.hidden = false;

  var linesEl = root.querySelector('[data-cart-lines]');
  var emptyEl = root.querySelector('[data-cart-empty]');
  var footEl = root.querySelector('[data-cart-foot]');
  var subEl = root.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function fmt(cents) {
    var f = window.ygeiaMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    return f
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
      .replace(/<[^>]*>/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }

  function open() { root.setAttribute('data-open', ''); document.body.style.overflow = 'hidden'; }
  function close() { root.removeAttribute('data-open'); document.body.style.overflow = ''; }

  function lineHTML(item) {
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="ycartline__variant">' + esc(item.variant_title) + '</p>' : '';
    var img = item.image
      ? '<img class="ycartline__img" src="' + esc(item.image) + '" alt="" loading="lazy">' : '<span></span>';
    return '<li class="ycartline" data-key="' + esc(item.key) + '">'
      + img
      + '<div><p class="ycartline__title">' + esc(item.product_title) + '</p>' + variant
      + '<span class="ycartline__qty">'
      + '<button type="button" data-step="-1" aria-label="Reduce quantity">−</button>'
      + '<span data-qty>' + item.quantity + '</span>'
      + '<button type="button" data-step="1" aria-label="Increase quantity">+</button>'
      + '</span></div>'
      + '<div style="display:grid;gap:0.5rem;justify-items:end;">'
      + '<span class="ycartline__price">' + fmt(item.final_line_price) + '</span>'
      + '<button type="button" class="ycartline__remove" data-remove>Remove</button>'
      + '</div></li>';
  }

  function render(cart) {
    countEls.forEach(function (e) { e.textContent = cart.item_count; });
    emptyEl.hidden = cart.item_count > 0;
    footEl.hidden = cart.item_count === 0;
    linesEl.innerHTML = cart.items.map(lineHTML).join('');
    if (cart.item_count > 0) subEl.textContent = fmt(cart.total_price);
  }

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return getCart().then(render); }

  function addId(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(function (r) { return r.json(); });
  }

  function change(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(render);
  }

  // Intercept add-to-cart forms (product page) → AJAX add + open drawer.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    addId(fd.get('id'), fd.get('quantity') || 1)
      .then(refresh)
      .then(open)
      .catch(function () { form.submit(); });
  });

  // Open / close.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cart-close]')) { close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Quantity + remove within the drawer.
  linesEl.addEventListener('click', function (e) {
    var line = e.target.closest('[data-key]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var cur = parseInt((line.querySelector('[data-qty]') || {}).textContent, 10) || 1;
    if (e.target.closest('[data-remove]')) change(key, 0);
    else if (e.target.closest('[data-step]')) {
      var d = parseInt(e.target.closest('[data-step]').getAttribute('data-step'), 10);
      change(key, Math.max(0, cur + d));
    }
  });

  refresh();
})();
